// src/pages/supervisors/AddSupervisorPage/index.js

import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import FormFields from "./FormFields";
import { createSupervisor } from "../../../redux/slices/supervisors/supervisorsThunk";

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

const tailLayout = {
  wrapperCol: { offset: 6, span: 14 },
};

const AddSupervisorPage = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading } = useSelector((state) => state.supervisors.supervisorsList);

  const onFinish = (values) => {
    // Les noms des champs du formulaire (values) correspondent déjà au DTO du backend
    dispatch(createSupervisor(values))
      .unwrap() // .unwrap() permet d'entrer dans le .then() uniquement en cas de succès
      .then(() => {
        history.push("/superviseurs"); // Rediriger après succès
      })
      .catch((error) => {
        // Le toast d'erreur est déjà géré dans le thunk, on peut logguer ici si besoin
        console.error("Échec de la création du superviseur:", error);
      });
  };

  const onReset = () => {
    form.resetFields();
  };

  const navigateTo = (path) => {
    history.push(path);
  };

  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Ajouter un Nouveau Superviseur"
      />
      <Card bordered={false}>
        <Form
          {...layout}
          form={form}
          name="add-supervisor-form"
          onFinish={onFinish}
        >
          <FormFields />

          <Form.Item {...tailLayout}>
            <Space size="middle">
              <Button type="primary" htmlType="submit" loading={loading}>
                Créer le Superviseur
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Réinitialiser
              </Button>
              <Button type="link" htmlType="button" onClick={() => navigateTo("/superviseurs")}>
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AddSupervisorPage;